/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { ReactNode } from "react";

interface ScrollFlowProps {
  containerViewStyle?: object;
  children?: ReactNode;
}

const styles = {
  container: {},
};

export const ScrollFlow = (props: ScrollFlowProps) => {
  const { containerViewStyle, children } = props;
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        // pointerEvents: "none",":before": {content: '""',
        //   display: "table",
        //   clear: "both",
        // },
      }}
    >
      {children}
    </div>
  );
};
